import { SET_THEME } from "../actions/themeActions";
const INITIAL_STATE = {
  theme: null,
};

function themeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_THEME:
      return { ...state, theme: action.payload };
    default:
      return state;
  }
}

export default themeReducer;
